export enum MediaShareLinkQueries {
	GET_MEDIA_SHARE_LINKS = `
    query MediaShareLinks($where: MediaShareLinkDtoFilterInput, $first: Int, $after: String) {
        mediaShareLinks(
            where: $where,
            first: $first,
            after: $after,
            order: { creationDate: ASC }
        ) {
            totalCount
            nodes {
                id
                enabled
                creationDate
                mediaShareLinkDetails {
                    model {
                        code
                        name
                    }
                }
            }
        }
    }
    `
}
